module.exports = __webpack_public_path__ + "img/cv-logo.8ef37b56.svg";